import { createFileRoute } from '@tanstack/react-router'
import { ImportEmployeesDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import ImportEmployeesDialog from '@/routes/_app/-dialogs/import-employees'

export const Route = createFileRoute('/@modal/employees/import')({
  staticData: { slotScope: '/_app' },
  pendingComponent: ImportEmployeesDialogPending,
  component: ImportEmployeesSlot,
})

function ImportEmployeesSlot() {
  const slot = useModalSlot(Route)
  return <ImportEmployeesDialog {...slot} />
}
